import { useMemo } from 'react';
import { useRouter } from 'next/router';
import { useSummary, usePromotions } from '@/store';
import useTrackingCore from './core';

export default function useGlobalTracking() {
  const router = useRouter();

  const { trackEventWithCurrency } = useTrackingCore();
  const { promotions } = usePromotions();

  const globalTrackingFunctions = useMemo(() => {
    return {
      couponApplied: ({ code, discount, type }) => {
        trackEventWithCurrency('coupon_applied', {
          step_name: router.pathname,
          coupon_code: code,
          discount_value: discount,
          discuont_type: type,
        });
      },
    };
  }, [router.pathname, trackEventWithCurrency]);

  return globalTrackingFunctions;
}
